import { Edge } from 'reactflow'

import { DatableNode, EdgeTypeEnum, NodeTypeEnum, SourceHandleEnum, TargetHandleEnum } from '@ui/interfaces'
import { uuid } from '@ui/lib/utils'

// TODO: Add enum for edge handles

// There is a misalignment on how we store data for nodes versus how react flow represents them
export const createEdgeFromDB = ({
  currentNode,
  targetHandle,
  sourceHandle,
  placeholderId,
}: {
  currentNode: DatableNode
  targetHandle?: TargetHandleEnum
  sourceHandle?: SourceHandleEnum
  placeholderId?: string
}): Edge => {
  const { TARGET_LOGS, TARGET_SPANS, TARGET_METRICS } = TargetHandleEnum
  const { SOURCE_SPANS } = SourceHandleEnum
  const { LOG, SPAN, METRIC, PLACEHOLDER } = EdgeTypeEnum

  const firehoseNodeId = NodeTypeEnum.FIREHOSE

  // const currentId = placeholderId ? `${currentNode.id}` : `${currentNode.parentSliceId || firehoseNodeId}`
  const source = placeholderId ? `${currentNode.id}` : `${currentNode.parentSliceId || firehoseNodeId}`
  const target = placeholderId ? `${placeholderId}` : `${currentNode.id}`

  const id = `${uuid()}`

  const handleType = () => {
    switch (targetHandle) {
      case TARGET_LOGS:
        return LOG
      case TARGET_SPANS:
        return SPAN
      case TARGET_METRICS:
        return METRIC
      default:
        return PLACEHOLDER
    }
  }

  const newEdge: Edge = {
    id,
    source: source,
    sourceHandle: `${placeholderId ? SOURCE_SPANS : sourceHandle}`,
    target: target,
    targetHandle: `${placeholderId ? TARGET_SPANS : targetHandle}`,
    type: handleType(),
    animated: placeholderId ? true : false,
  }

  return newEdge
}

export const createEdge = ({
  source,
  target,
  targetHandle,
  sourceHandle,
  placeholder,
}: {
  source: string
  target: string
  targetHandle: TargetHandleEnum
  sourceHandle: SourceHandleEnum
  placeholder?: boolean
}): Edge => {
  const handleType = () => {
    const { TARGET_LOGS, TARGET_SPANS, TARGET_METRICS } = TargetHandleEnum
    const { LOG, SPAN, METRIC, PLACEHOLDER } = EdgeTypeEnum

    switch (targetHandle) {
      case TARGET_LOGS:
        return LOG
      case TARGET_SPANS:
        return SPAN
      case TARGET_METRICS:
        return METRIC
      default:
        return PLACEHOLDER
    }
  }

  const newEdge: Edge = {
    id: `${uuid()}`,
    source,
    sourceHandle,
    target,
    targetHandle,
    type: handleType(),
    animated: placeholder ? true : false,
    data: {},
  }

  return newEdge
}
